<template>
  <div class="stepperContainer">
    <div v-for="(item, index) in steps[0].tabs" class="stepperIconDiv">
      <div class="stepperIconContainer" @click="$emit('onStepClick', index)">
        <span class="iconLabel" :class="{ incomplete: index > currentStep }">{{
          index + 1
        }}</span>
        <stepperIconCurrent v-if="index === currentStep" class="iconClass" />
        <stepperIconIncomplete v-if="index > currentStep" class="iconClass" />
        <stepperIconComplete v-if="index < currentStep" class="iconClass" />
        <stepperLineIncomplete
          v-if="index >= currentStep && index + 1 !== steps[0].tabs.length"
        />
        <stepperLineComplete
          v-if="index < currentStep && index + 1 !== steps[0].tabs.length"
        />
      </div>
      <span
        class="stepperLabel"
        :class="{ 
            incompleteLabel: index > currentStep,
            labelFix: index + 1 !== steps[0].tabs.length
        }"
        >{{ item.label }}
      </span>
    </div>
  </div>
</template>

<script>
import stepperIconCurrent from "@/assets/stepperSVGs/stepperIconCurrent.svg";
import stepperIconComplete from "@/assets/stepperSVGs/stepperIconComplete.svg";
import stepperIconIncomplete from "@/assets/stepperSVGs/stepperIconIncomplete.svg";
import stepperLineComplete from "@/assets/stepperSVGs/stepperLineComplete.svg";
import stepperLineIncomplete from "@/assets/stepperSVGs/stepperLineIncomplete.svg";

export default {
  name: "Stepper",

  components: {
    stepperIconCurrent,
    stepperIconComplete,
    stepperIconIncomplete,
    stepperLineComplete,
    stepperLineIncomplete,
  },

  props: {
    currentStep: {
      Type: Number,
      default: 0,
    },
    steps: {
      Type: Array,
      default: [],
    }
  },

  data() {
    return {
      key: 0,
      // dataTest: [
      //   {
      //     label: "Ducts",
      //   },
      //   {
      //     label: "Ducts",
      //   },
      //   {
      //     label: "Ducts",
      //   },
      //   {
      //     label: "Ducts",
      //   },
      //   {
      //     label: "Ducts",
      //   },
      //   {
      //     label: "Ducts",
      //   },
      // ],
    };
  },

  methods: {},
};
</script>

<style scoped>
.stepperContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.stepperLabel {
  color: #767676;
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 266.667% */
  margin-left: 16px;
}

.stepperIconContainer {
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
}

.stepperIconDiv {
  display: flex;
  align-items: center;
}

.iconLabel {
  position: absolute;
  top: 6px;
  color: #fff;
  text-align: center;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 171.429% */
}

.incomplete {
  color: rgba(79, 162, 183, 0.5);
}

.labelFix {
    margin-bottom: 36px;
}

.incompleteLabel {
  color: rgba(118, 118, 118, 0.5);
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 266.667% */
}

.iconClass {
  margin: 2px 0px 2px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Organisms/Stepper.vue